// 生涯档案(升学途径主页面)
const wayToStudyWays = () => import('../views/wayToStudyWays/main.vue');

// 升学途径--升学途径分析（入口）
const TestEntry = () => import('../views/wayToStudyWays/analysis_test/test_entry.vue');
// 升学途径分析（测试题）
const TestMain= () => import('../views/wayToStudyWays/analysis_test/test_main.vue');
// 升学途径分析（测试题报告）
// const TestReport= () => import('../views/wayToStudy/analysis_test/test_report.vue');






// 升学途径--常见升学途径（自主招生、艺术类招生、体育类专业、综合评价录取）
const AutonomousEnrollment = () => import('../views/wayToStudyWays/common_school_path/AutonomousEnrollment.vue');
const ArtEnrollment = () => import('../views/wayToStudyWays/common_school_path/ArtEnrollment.vue');
const SportsMajor = () => import('../views/wayToStudyWays/common_school_path/SportsMajor.vue');
const ComprehensiveEvaluation = () => import('../views/wayToStudyWays/common_school_path/ComprehensiveEvaluation.vue');
// 升学途径其他主流途径（三大专项计划、公费师范生、免费医学生、保送生、高水平艺术团、高水平运动队、体育单招、高职单招）
// 三大专项计划
const ThreeSpecialPlan = () => import('../views/wayToStudyWays/other_main_path/ThreeSpecialPlan.vue');
// 公费师范生
const PublicExpense = () => import('../views/wayToStudyWays/other_main_path/PublicExpense.vue');
// 免费医学生
const FreeMedicalStudents = () => import('../views/wayToStudyWays/other_main_path/FreeMedicalStudents.vue');
// 保送生
const RecommendedStudent = () => import('../views/wayToStudyWays/other_main_path/RecommendedStudent.vue');
// 高水平艺术团
const ArtEnsemble = () => import('../views/wayToStudyWays/other_main_path/ArtEnsemble.vue');
// 高水平运动队
const SportsTeam = () => import('../views/wayToStudyWays/other_main_path/SportsTeam.vue');
// 体育单招
const Tiyudanzhao = () => import('../views/wayToStudyWays/other_main_path/Tiyudanzhao.vue');
// 高职单招
const Gaozhidanzhao = () => import('../views/wayToStudyWays/other_main_path/Gaozhidanzhao.vue');

// 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校)
const CivilAviation = () => import('../views/wayToStudyWays/military_scholl/CivilAviation.vue');
const SeaForce = () => import('../views/wayToStudyWays/military_scholl/SeaForce.vue');
const AirForce = () => import('../views/wayToStudyWays/military_scholl/AirForce.vue');
const MilitarySchool = () => import('../views/wayToStudyWays/military_scholl/MilitarySchool.vue');
const PoliceSchool = () => import('../views/wayToStudyWays/military_scholl/PoliceSchool.vue');
const NauticalCategorySchool = () => import('../views/wayToStudyWays/military_scholl/NauticalCategorySchool.vue');

// 其他升学途径(民族预科班、港澳招生、中外合作、海外留学)
const NationPrepClass = () => import('../views/wayToStudyWays/other_goschool_path/NationPrepClass.vue');
const GangaoRecruitstudents = () => import('../views/wayToStudyWays/other_goschool_path/GangaoRecruitstudents.vue');
const SinoForeignCooperation = () => import('../views/wayToStudyWays/other_goschool_path/SinoForeignCooperation.vue');
const StudyingAbroad = () => import('../views/wayToStudyWays/other_goschool_path/StudyingAbroad.vue');


// 新增
// 强基计划
const BasicPlan  = () => import('../views/wayToStudyWays/add_goschool_path/BasicPlan.vue');
// 公费农科生
const AgriculturalStudents  = () => import('../views/wayToStudyWays/add_goschool_path/AgriculturalStudents.vue');
// 定向生
const DirectionalStudents  = () => import('../views/wayToStudyWays/add_goschool_path/DirectionalStudents.vue');
// 小语种
const MinorLanguages  = () => import('../views/wayToStudyWays/add_goschool_path/MinorLanguages.vue');
// 普通升学
const GeneralEntrance  = () => import('../views/wayToStudyWays/add_goschool_path/GeneralEntrance.vue');

// 
export default
    {
        path:'/wayToStudyWays',
        name:'升学途径',
        redirect:'/wayToStudyWays/main',
        component:()=>import('../views/wayToStudyWays/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            // 升学途径主页面
            // 生涯档案(升学途径)
            {
                path: '/wayToStudyWays/main',
                component:wayToStudyWays,
                meta:{requireAuth:true,roles:['student']},
            },
            // 升学途径分析（入口-开始测试）
            {
                path: '/wayToStudyWays/testentry',
                component:TestEntry ,
                meta:{requireAuth:true,roles:['student']},
            },
            // 升学途径分析（测试）
            {
                path: '/wayToStudyWays/testmain',
                component:TestMain,
                meta:{requireAuth:true,roles:['student']},
            },

            // 升学途径分析（测试结果报告）
            // {
            //     path: '/wayToStudy/testreport',
            //     component:TestReport
            // },
            // 升学途径--常见升学途径（自主招生、艺术类招生、体育类专业、综合评价录取）
            // 自主招生
            {
                path: '/wayToStudyWays/autonomousenrollment',
                component:AutonomousEnrollment,
                meta:{requireAuth:true,roles:['student']},
            },
            // 艺术类招生
            {
                path: '/wayToStudyWays/artenrollment',
                component:ArtEnrollment,
                meta:{requireAuth:true,roles:['student']},
            },
            // 体育类专业
            {
                path: '/wayToStudyWays/sportsmajor',
                component:SportsMajor,
                meta:{requireAuth:true,roles:['student']},
            },
            // 综合评价录取
            {
                path: '/wayToStudyWays/comprehensiveevaluation',
                component:ComprehensiveEvaluation,
                meta:{requireAuth:true,roles:['student']},
            },
            // 升学途径其他主流途径（三大专项计划、公费师范生、免费医学生、保送生、高水平艺术团、高水平运动队、体育单招、高职单招）
            // 三大专项计划
            {
                path: '/wayToStudyWays/threespecialplan',
                component:ThreeSpecialPlan,
                meta:{requireAuth:true,roles:['student']},
            },
            // 公费师范生
            {
                path: '/wayToStudyWays/publicexpense',
                component:PublicExpense,
                meta:{requireAuth:true,roles:['student']},
            },
            // 免费医学生
            {
                path: '/wayToStudyWays/freemedicalstudents',
                component:FreeMedicalStudents,
                meta:{requireAuth:true,roles:['student']},
            },
            // 保送生
            {
                path: '/wayToStudyWays/recommendedstudent',
                component:RecommendedStudent,
                meta:{requireAuth:true,roles:['student']},
            },
            // 高水平艺术团
            {
                path: '/wayToStudyWays/artensemble',
                component:ArtEnsemble,
                meta:{requireAuth:true,roles:['student']},
            },
            // 高水平运动队
            {
                path: '/wayToStudyWays/sportsteam',
                component:SportsTeam,
                meta:{requireAuth:true,roles:['student']},
            },
            // 体育单招
            {
                path: '/wayToStudyWays/tiyudanzhao',
                component:Tiyudanzhao,
                meta:{requireAuth:true,roles:['student']},
            },
            // 高职单招
            {
                path: '/wayToStudyWays/gaozhidanzhao',
                component:Gaozhidanzhao,
                meta:{requireAuth:true,roles:['student']},
            },
            // 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校)
            // 民航招飞
            {
                path: '/wayToStudyWays/civilaviation',
                component:CivilAviation,
                meta:{requireAuth:true,roles:['student']},
            },
            // 海军招飞
            {
                path: '/wayToStudyWays/seaforce',
                component:SeaForce,
                meta:{requireAuth:true,roles:['student']},
            },
            // 空军招飞
            {
                path: '/wayToStudyWays/airforce',
                component:AirForce,
                meta:{requireAuth:true,roles:['student']},
            },
            // 军校招生
            {
                path: '/wayToStudyWays/militaryschool',
                component:MilitarySchool,
                meta:{requireAuth:true,roles:['student']},
            },
            // 公安院校
            {
                path: '/wayToStudyWays/policeschool',
                component:PoliceSchool,
                meta:{requireAuth:true,roles:['student']},
            },
            // 航海类院校
            {
                path: '/wayToStudyWays/nauticalcategoryschool',
                component:NauticalCategorySchool,
                meta:{requireAuth:true,roles:['student']},
            },
            // 其他升学途径(民族预科班、港澳招生、中外合作、海外留学)
            // 民族预科班
            {
                path: '/wayToStudyWays/nationprepclass',
                component:NationPrepClass,
                meta:{requireAuth:true,roles:['student']},
              },
            // 港澳招生
            {
                path: '/wayToStudyWays/gangaorecruitstudents',
                component:GangaoRecruitstudents,
                meta:{requireAuth:true,roles:['student']},
            },
            // 中外合作
            {
                path: '/wayToStudyWays/sinoforeigncooperation',
                component:SinoForeignCooperation,
                meta:{requireAuth:true,roles:['student']},
            },
            // 海外留学
            {
                path: '/wayToStudyWays/studyingabroad',
                component:StudyingAbroad,
                meta:{requireAuth:true,roles:['student']},
            },
            // 新增分类
            // 强基计划
            {
                path: '/wayToStudyWays/BasicPlan',
                component:BasicPlan,
                meta:{requireAuth:true,roles:['student']},
            },
            // 公费农科生
            {
                path: '/wayToStudyWays/AgriculturalStudents',
                component:AgriculturalStudents,
                meta:{requireAuth:true,roles:['student']},
            },
            // 定向生
            {
                path: '/wayToStudyWays/DirectionalStudents',
                component:DirectionalStudents,
                meta:{requireAuth:true,roles:['student']},
            },
            // 小语种
            {
                path: '/wayToStudyWays/MinorLanguages',
                component:MinorLanguages,
                meta:{requireAuth:true,roles:['student']},
            },
            
            // 普通升学
            {
                path: '/wayToStudyWays/GeneralEntrance',
                component:GeneralEntrance,
                meta:{requireAuth:true,roles:['student']},
            },
        ]
    }
